import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=58c5ff20&scoped=true"
import script from "./InfoTable.vue?vue&type=script&lang=js"
export * from "./InfoTable.vue?vue&type=script&lang=js"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=58c5ff20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5ff20",
  null
  
)

export default component.exports